import React from "react"
//import ReactDOM from "react-dom"
import { createRoot } from "react-dom/client"
import "./css/style.css"
import App from "./App"
import { CookiesProvider } from "react-cookie"

const container = document.getElementById("root")
const root = createRoot(container) // create a root
root.render(
  // <React.StrictMode>
  <CookiesProvider>
    <App />
  </CookiesProvider>
  // </React.StrictMode>
)
